import { createContext, Dispatch, SetStateAction } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

export interface TextEditorContext {
  /**
   * 'userGeneratedContent' -- includes padding, but not white-labeled (intended for document summaries on-site)
   * 'contextContent' -- no padding, not white-labeled (intended for the contextual help drawer)
   * 'presentationContent' -- no padding, white-labeled (intended for presentations)
   */
  theme: 'userGeneratedContent' | 'contextContent' | 'presentationContent';
  setTheme: Dispatch<SetStateAction<TextEditorContext['theme']>>;
}

export const TextEditorContext = createContext<TextEditorContext>({
  theme: 'userGeneratedContent',
  setTheme: () => null,
});

export const useTextEditorContext = () => {
  return useGuardedContext(TextEditorContext, 'TextEditorProvider');
};
